import { ActionTree } from 'vuex'

import { RootState } from '@/store/types'

import { CarereceiverPageData, CarereceiverState, Mutations } from './types'

const actions: ActionTree<CarereceiverState, RootState> = {
  setCarereceiverProfile({ commit }, payload: CarereceiverPageData) {
    commit(Mutations.SET_CARERECEIVER_PROFILE, payload)
  },

  setCareReceiverIdForCurrentBookingFunnel({ commit }, crId?: string) {
    commit(Mutations.SET_CARERECEIVER_ID_FOR_CURRENT_BOOKING_FUNNEL, crId)
  },
}

export default actions
